import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, Observer, of } from 'rxjs';
import { tap } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { SecretService } from './secret.service';
import { CacheService } from './cache.service';
// import { AppConfig } from './config/app.config';

@Injectable({
  providedIn: 'root',
})
export class AdminService {
  getTrainingCompletionStats() {
    throw new Error('Method not implemented.');
  }
  baseUrl: any;
  // siteBaseUrl: any;
  constructor(
    private http: HttpClient,
    private secretServ: SecretService,
    private cacheService: CacheService
  ) {
    this.baseUrl = environment.baseUrl;
    // this.siteBaseUrl = environment.siteBaseUrl;
  }

  /**
   * Service for register the tanent of CM.
   * Created by Rashmi Ranjan
   * @Phantom
   * CreatedOn 03-Dec-2021
   */
  listAdminUser(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/list-admin-user', payload);
  }

  listAllUsers(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/list-all-user', payload);
  }

  getMemberStats(payload: any = {}): Observable<any> {
    return this.http.post(this.baseUrl + 'user/member-stats', payload);
  }
  listLearnerUsers(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/list-learner-user', payload);
  }

  deletedMemberList(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/deleted-member-list', payload);
  }

  restoreMember(id: string): Observable<any> {
    return this.http.post(this.baseUrl + `user/${id}/restore-member`, {});
  }

  updateMemberSettings(id: string, payload: any): Observable<any> {
    return this.http.post(this.baseUrl + `user/${id}/user-settings`, payload);
  }

  deleteMember(id: string): Observable<any> {
    return this.http.post(this.baseUrl + `user/${id}/hard-delete`, {});
  }

  bulkDeleteMembers(ids: string[]): Observable<any> {
    return this.http.post(this.baseUrl + 'user/bulk-hard-delete', { ids });
  }
  // viewUser(): Observable<any> {
  //   return this.http.get(this.baseUrl + 'user/view-user');
  // }
  viewUserId(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/view-user', payload);
  }
  addAdminUser(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/save-admin-user', payload);
  }
  deleteUser(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/delete-user', payload);
  }
  updateUserStatus(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/update-user-status', payload);
  }
  bulkUpdateUser(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/bulk-update-user', payload);
  }
  getSupervisorList(): Observable<any> {
    return this.http.get(this.baseUrl + 'user/list-supervisor-user');
  }
  getEngineerList(): Observable<any> {
    return this.http.get(this.baseUrl + 'user/list-engineer-user');
  }
  // getClientList(): Observable<any> {
  //   return this.http.get(this.baseUrl + 'user/list-client-user');
  // }
  getClientList(): Observable<any> {
    return this.http.get(this.baseUrl + 'user/list-clients');
  }
  getActiveUsersCount(): Observable<any> {
    return this.http.get(this.baseUrl + 'user/get-active-user-count');
  }

  // other users list
  getAllOtherUsers(): Observable<any> {
    return this.http.get(this.baseUrl + 'user/list-other-user');
  }

  //Country list
  getCountryList(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'master/list-country', payload);
  }

  getLearnerCountryList(): Observable<any> {
    return this.http.post(this.baseUrl + 'master/list-country', { status: true });
  }

  getCurrencyList(payload: any): Observable<any> {
    return this.http.get(this.baseUrl + 'master/get-currency-list', payload);
  }
  changeImage(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/change-profile-pic', payload);
  }
  deleteImage(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/change-profile-pic', payload);
  }

  /** client managemant */
  // addClientUser(payload: any): Observable<any> {
  //   return this.http.post(this.baseUrl + 'user/save-client-user', payload);
  // }
  // getClientlist(payload: any): Observable<any> {
  //   return this.http.post(this.baseUrl + 'user/get-client-list', payload);
  // }
  // viewClientlist(payload: any): Observable<any> {
  //   return this.http.post(this.baseUrl + 'user/view-client', payload);
  // }
  // viewClientInfo(payload: any): Observable<any> {
  //   return this.http.post(this.baseUrl + 'user/view-client-info', payload);
  // }
  // updateClientStatus(payload: any): Observable<any> {
  //   return this.http.post(this.baseUrl + 'user/update-client-status', payload);
  // }
  // deleteClient(payload: any): Observable<any> {
  //   return this.http.post(this.baseUrl + 'user/delete-client', payload);
  // }
  // bulkUpdateClient(payload: any): Observable<any> {
  //   return this.http.post(
  //     this.baseUrl + 'user/bulk-update-client-status',
  //     payload
  //   );
  // }

  saveSupervisor(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/save-supervisor-user', payload);
  }
  getSupervisors(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/get-supervisors', payload);
  }
  viewSupervisor(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/view-supervisor', payload);
  }
  deleteSupervisor(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/delete-supervisor', payload);
  }
  updateSupervisorStatus(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/update-supervisor-status', payload);
  }
  bulkUpdateSupervisor(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/bulk-update-supervisor', payload);
  }

  saveAreaManager(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/save-area-manager-user', payload);
  }
  getAreaManagers(): Observable<any> {
    return this.http.get(this.baseUrl + 'user/get-area-managers');
  }
  viewAreaManager(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/view-area-manager', payload);
  }
  deleteAreaManager(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/delete-area-manager', payload);
  }
  updateAreaManagerStatus(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/update-area-manager-status', payload);
  }
  bulkUpdateAreaManager(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/bulk-update-area-manager-status', payload);
  }

  saveEngineer(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/save-engineer-user', payload);
  }
  getEngineers(): Observable<any> {
    return this.http.get(this.baseUrl + 'user/get-engineers');
  }
  viewEngineer(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/view-engineer', payload);
  }
  deleteEngineer(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/delete-engineer', payload);
  }
  updateEngineerStatus(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/update-engineer-status', payload);
  }
  bulkUpdateEngineer(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/bulk-update-engineer', payload);
  }

  updateImage(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/update-image', payload);
  }
  updatePassword(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/update-password', payload);
  }
  resetPassword(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/resetPassword', payload);
  }
  sendQRViaEmail(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/sendQRbyEmail', payload);
  }
  showQR(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/singleUserQR', payload);
  }

  getSamClient(): Observable<any> {
    return this.http.post(this.baseUrl + 'site/fetch-CD-ccsClientBE', {});
  }

  getSamSite(country_code: any, sage_no: any): Observable<any> {
    return this.http.post(this.baseUrl + 'site/fetch-CD-ccsSitesBE', {
      country_code,
      sage_no,
    });
  }

  forgotPass(payload: { email: string }): Observable<any> {
    // console.log(payload);
    return this.http.post(this.baseUrl + 'user/forgot-password', payload);
  }

  resetNewPassword(email: string, token: string, newPassword: string): Observable<any> {
    return this.http.post(this.baseUrl + 'user/reset-new-password', {
      email,
      token,
      newPassword,
    });
  }

  sendContact(): Observable<any> {
    return this.http.post(this.baseUrl + 'user/send-request-by-email ', {
      _id: this.secretServ.decryptLocalStorageData(localStorage.getItem('user_id')),
      email: this.secretServ.decryptLocalStorageData(localStorage.getItem('emailId')),
    });
  }

  importSupervisor(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/import-supervisor', payload);
  }

  importAreaManager(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/import-area-manager', payload);
  }

  importClient(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/import-client', payload);
  }

  clientSync(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/clientSyncAllData', payload);
  }

  saveOperationManager(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/save-operation-manager-user', payload);
  }

  saveRole(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/role-change-Users', payload);
  }
  // http://localhost:8000/auth/api/v1/user/role-change-Users

  listOperationManagers(): Observable<any> {
    return this.http.get(this.baseUrl + 'user/list-operation-manager-user');
  }

  deleteOperationManager(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/delete-operation-manager-user', payload);
  }

  updateOperationManagerStatus(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/update-operation-manager-status', payload);
  }

  bulkUpdateOperationManagerStatus(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/bulk-update-operation-manager-status', payload);
  }

  countryWiseClientList(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/country-wise-client-list', payload);
  }

  listAllClient(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/list-all-client', payload);
  }

  listSuperAdminUser(): Observable<any> {
    return this.http.get(this.baseUrl + 'user/list-super-admin-user');
  }

  clientSupportTicket(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/client-support-ticket', payload);
  }

  /****** Support Manager *******/
  saveSupportManager(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/save-support-manager', payload);
  }

  listSupportManager(): Observable<any> {
    return this.http.get(this.baseUrl + 'user/list-support-manager');
  }

  listActiveSupportManager(): Observable<any> {
    return this.http.get(this.baseUrl + 'master/support-manager-dropdown-list');
  }

  checkClientQEHS(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/check-client-qehs', payload);
  }

  roleDropdownList(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'master/role-dropdown-list', payload);
  }

  syncAllAdmin(): Observable<any> {
    return this.http.get(this.baseUrl + 'user/adminSyncAllData');
  }

  syncAllOpManager(): Observable<any> {
    return this.http.get(this.baseUrl + 'user/OMSyncAllData');
  }

  syncAllSupportManager(): Observable<any> {
    return this.http.get(this.baseUrl + 'user/SMSyncAllData');
  }

  getCalendarData(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/fetch-calender', payload);
  }

  getBCCompanyList(): Observable<any> {
    return this.http.get(this.baseUrl + 'user/BC-companyList');
  }

  getVanTrackingCustomerList(): Observable<any> {
    return this.http.get(this.baseUrl + 'user/vanTracking-customerList');
  }

  getVanTrackingDeviceLocation(payload: any, accessToken: any, token: any): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        authorization: `Bearer ${accessToken}, Token ${token}`,
      }),
    };
    return this.http.post(
      this.baseUrl + 'user/vanTracking-customer-device-Location',
      payload,
      httpOptions
    );
  }

  getAllSiteAM(data: any) {
    const payload = { am_emails: [...data] };
    return this.http.post(this.baseUrl + 'user/get-all-site-ams', payload);
  }

  getAllRoles() {
    return this.http.get(this.baseUrl + 'user/all-roles');
  }

  getAllStockWarehouse() {
    return this.http.get(this.baseUrl + 'master/get-stock-warehouse-list');
  }
  createMachine(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'machine/add-machine', payload);
  }
  machineList(params?: any) {
    const queryParams: any = {};
    if (params?.manufacturerId) {
      queryParams.manufacturerId = params.manufacturerId;
    }
    if (params?.machineTypeId) {
      queryParams.machineTypeId = params.machineTypeId;
    }
    return this.http.get(this.baseUrl + 'machine/get-machine-list', { params: queryParams });
  }
  deleteMachine(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'machine/delete-machine', payload);
  }
  deleteMachineInstance(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'machine/delete-machine-instance', payload);
  }
  updateMachineStatus(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'machine/update-machine-status', payload);
  }
  getMachineDetails(machineId: string) {
    return this.http.get(this.baseUrl + `machine/get-machine-details/${machineId}`);
  }
  bulkUpdateMachine(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'machine/bulk-update-machine', payload);
  }
  addContract(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'manageClient/add-contract', payload);
  }
  contractList(params?: any) {
    const queryParams: any = {};
    if (params?.clientId) {
      queryParams.clientId = params.clientId;
    }
    return this.http.get(this.baseUrl + 'manageClient/get-contract-list', {
      params: queryParams,
    });
  }
  deleteContract(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'manageClient/delete-contract', payload);
  }
  updateContractStatus(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'manageClient/update-contract-status', payload);
  }
  bulkUpdateContract(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'manageClient/bulk-update-contract', payload);
  }
  getContractDetails(contractId: string) {
    return this.http.get(this.baseUrl + `manageClient/get-contract-details/${contractId}`);
  }
  addSector(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'manageClient/add-sector', payload);
  }
  sectorList(params?: any) {
    const queryParams: any = {};
    if (params?.contractId) {
      queryParams.contractId = params.contractId;
    }
    if (params?.clientId) {
      queryParams.clientId = params.clientId;
    }
    return this.http.get(this.baseUrl + 'manageClient/get-sector-list', {
      params: queryParams,
    });
  }
  deleteSector(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'manageClient/delete-sector', payload);
  }
  updateSectorStatus(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'manageClient/update-sector-status', payload);
  }
  bulkUpdateSector(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'manageClient/bulk-update-sector', payload);
  }
  getSectorDetails(sectorId: string) {
    return this.http.get(this.baseUrl + `manageClient/get-sector-details/${sectorId}`);
  }
  /** client managemant */
  // addClient(payload: any): Observable<any> {
  //   return this.http.post(this.baseUrl + 'manageClient/add-client', payload);
  // }
  clientList() {
    return this.http.get(this.baseUrl + 'manageClient/get-client-list');
  }
  // deleteClient(payload: any): Observable<any> {
  //   return this.http.post(this.baseUrl + 'manageClient/delete-client', payload);
  // }
  updateClientStatus(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'manageClient/update-client-status', payload);
  }
  bulkUpdateClient(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'manageClient/bulk-update-client', payload);
  }
  // getClientDetails(clientId: string) {
  //   return this.http.get(this.baseUrl + `manageClient/get-client-details/${clientId}`);
  // }

  /* Site Staff */
  saveSite(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'site/save-site', payload);
  }

  // getAllSite(): Observable<any> {
  //   return this.http.get(this.baseUrl + 'site/get-all-site');
  // }
  getAllSite(params?: any) {
    const queryParams: any = {};
    if (params?.cityName) {
      queryParams['cityName'] = params.cityName;
    }
    if (params?.clientId) {
      queryParams.clientId = params.clientId;
    }
    if (params?.countryId) {
      queryParams.countryId = params.countryId;
    }
    return this.http.get(this.baseUrl + 'site/get-all-site', {
      params: queryParams,
    });
  }

  siteStatusChange(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'site/site-status-change', payload);
  }

  getSingleSite(params: { _id: string }) {
    const queryParams: { _id: string } = {
      _id: params._id ? params._id : '',
    };
    return this.http.get(this.baseUrl + 'site/get-single-site', { params: queryParams });
  }

  getAreaManagerList(params?: any) {
    const queryParams: any = {};
    if (params?.clientId) {
      queryParams.clientId = params.clientId;
    }
    return this.http.get(this.baseUrl + 'site/get-areaManager-list', {
      params: queryParams,
    });
  }

  getCity(clientId: string, countryIds: string): Observable<any> {
    const queryParams = new HttpParams().set('clientId', clientId).set('countryIds', countryIds);

    return this.http.get(this.baseUrl + 'site/get-city', { params: queryParams });
  }
  updateAreaManager(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'site/update-site-area-manger', payload);
  }
  addManufacturer(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'machine/add-manufacturer', payload);
  }
  getAllManufacturer() {
    return this.http.get(this.baseUrl + 'machine/get-manufacturer-list');
  }
  deleteManufacturer(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'machine/delete-manufacturer', payload);
  }
  updateManufacturerStatus(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'machine/update-manufacturer-status', payload);
  }
  bulkUpdateManufacturer(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'machine/bulk-update-manufacturer', payload);
  }
  getManufacturerDetails(manufacturerId: string) {
    return this.http.get(this.baseUrl + `machine/get-manufacturer-details/${manufacturerId}`);
  }

  addMachineType(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'machine/add-machinetype', payload);
  }
  getAllMachineType() {
    return this.http.get(this.baseUrl + 'machine/get-machine-type-list');
  }
  deleteMachinetype(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'machine/delete-machinetype', payload);
  }
  updateMachinetypeStatus(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'machine/update-machinetype-status', payload);
  }
  bulkUpdateMachinetype(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'machine/bulk-update-machinetype', payload);
  }
  getMachinetypeDetails(machinetypeId: string) {
    return this.http.get(this.baseUrl + `machine/get-machinetype-details/${machinetypeId}`);
  }
  getAllSiteMachineDetails(site_id: string) {
    return this.http.get(this.baseUrl + `machine/get-site-machine-details/${site_id}`);
  }

  addSiteMachine(payload: any) {
    return this.http.post(this.baseUrl + 'machine/add-machine-fields', payload);
  }

  deleteSiteMachine(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'machine/delete-site-machine', payload);
  }

  // Devadatta
  getClientsAc(payload: any): Observable<any> {
    console.log('>>>>>>>>>>>>>>>>', payload);
    return this.http.post(this.baseUrl + 'manageClient/get-client-list-ac', payload);
  }

  getNextJobID() {
    return this.http.post(this.baseUrl + 'jobs/get-next-job-id', {});
  }
  getClientContractList(clientId: string) {
    return this.http.post(this.baseUrl + `manageClient/client/${clientId}/contracts`, null);
  }
  getClientCountryList(clientId: string) {
    return this.http.post(this.baseUrl + `manageClient/client/${clientId}/countries`, null);
  }

  getClientSiteList(clientId: string, params?: any) {
    return this.http.post(this.baseUrl + `manageClient/client/${clientId}/sites`, params);
  }
  getMultiClientSiteList(clientIds: string, params?: any) {
    return this.http.post(this.baseUrl + `manageClient/client-sites`, {
      clientIds,
      ...params,
    });
  }

  createJob(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'jobs/create', payload);
  }

  getJobsList(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'jobs/get-jobs', payload);
  }
  getExportJobsList(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'jobs/export-jobs', payload);
  }

  getJobDetails(jobId: string, params?: any): Observable<any> {
    return this.http.post(this.baseUrl + `jobs/${jobId}/details`, params);
  }
  updateJob(jobId: string, payload: any): Observable<any> {
    return this.http.post(this.baseUrl + `jobs/${jobId}/update`, payload);
  }

  importSite(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'site/save-bulk-site', payload);
  }

  importBulkMachineSite(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'machine/import-site-machine', payload);
  }

  deleteJob(jobId: string): Observable<any> {
    return this.http.post(this.baseUrl + `jobs/${jobId}/delete`, {});
  }

  attachJobImages(jobId: string, payload: any): Observable<any> {
    return this.http.post(this.baseUrl + `jobs/${jobId}/attach-images`, payload);
  }

  // get all machines of a site
  fetchSiteMachines(siteId: string) {
    return this.http.post(this.baseUrl + `jobs/get-site-machines/${siteId}`, {});
  }

  attachMachineToJob(jobId: string, payload: any): Observable<any> {
    return this.http.post(this.baseUrl + `jobs/${jobId}/attach-a-machine`, payload);
  }

  detachMachineFromJob(jobId: string, payload: any): Observable<any> {
    return this.http.post(this.baseUrl + `jobs/${jobId}/detach-a-machine`, payload);
  }

  // job machines
  getJobMachines(jobId: string): Observable<any> {
    return this.http.post(this.baseUrl + `jobs/${jobId}/machines`, {});
  }
  // assign-engineer
  assignEngineerToJob(jobId: string, payload: any): Observable<any> {
    return this.http.post(this.baseUrl + `jobs/${jobId}/assign-engineer`, payload);
  }
  // getAllEngineersForJob
  getAllEngineersForJob(jobId: string) {
    return this.http.post(this.baseUrl + `jobs/${jobId}/available-engineers`, {});
  }

  // getAllEngineersForMultiStepJob
  getAllEngineersForMultiStepJob(payload: { siteId?: string } = {}) {
    return this.http.post(this.baseUrl + 'jobs/all-engineers', payload);
  }

  // getAssignedEngineerLogs
  getAssignedEngineerLogs(jobId: string) {
    return this.http.post(this.baseUrl + `jobs/${jobId}/assigned-engineer-logs`, {});
  }
  // Job Logs
  getJobLogs(jobId: string) {
    return this.http.post(this.baseUrl + `jobs/${jobId}/logs`, {});
  }

  // all statuses
  getAllStatuses() {
    return this.http.get(this.baseUrl + 'jobs/job-statuses');
  }

  // change job status
  changeJobStatus(jobId: string, payload: any): Observable<any> {
    return this.http.post(this.baseUrl + `jobs/${jobId}/change-status`, payload);
  }

  getDeletedJobsList(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'jobs/get-deleted-jobs', payload);
  }

  // restoreJob
  restoreJob(jobId: string): Observable<any> {
    return this.http.post(this.baseUrl + `jobs/${jobId}/restore`, {});
  }
  // permanentDeleteJob
  permanentDeleteJob(jobId: string): Observable<any> {
    return this.http.post(this.baseUrl + `jobs/${jobId}/permanent-delete`, {});
  }

  getSiteJobDetails(siteId: string, payload: any) {
    return this.http.post(this.baseUrl + `jobs/get-site-jobs/${siteId}`, payload);
  }

  // work-sessions
  getWorkSessions(jobId: string) {
    return this.http.post(this.baseUrl + `jobs/${jobId}/work-sessions`, {});
  }

  // session-info
  getSessionInfo(jobId: string, sessionId: string) {
    return this.http.post(this.baseUrl + `jobs/${jobId}/work-sessions/${sessionId}/info`, {});
  }

  getManufacturerAc(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'machine/get-manufacturer-list-ac', payload);
  }

  getOpenedJobsListForDashboard(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'jobs/get-opened-jobs', payload);
  }

  getCompletedJobsListForDashboard(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'jobs/get-completed-jobs', payload);
  }

  getDashboardJobs(listType: string, limit: number, params: object = {}): Observable<any> {
    return this.http.post(this.baseUrl + 'jobs/get-dashboard-jobs', { listType, limit, ...params });
  }

  getDashboardJobs2(params: object = {}): Observable<any> {
    return this.http.post(this.baseUrl + 'jobs/get-dashboard-jobs', { ...params });
  }

  errorList(params?: any) {
    return this.http.get(this.baseUrl + 'jobs/get-error-list', params);
  }

  addMachineService(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'machine/add-machine-service', payload);
  }

  getMachineServiceDetails(id: string): Observable<any> {
    return this.http.get(this.baseUrl + `machine/get-service-details/${id}`);
  }

  getJobServiceDetails(jobId: string): Observable<any> {
    return this.http.get(this.baseUrl + `machine/get-job-service-details/${jobId}`);
  }

  deleteServiceDetails(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'machine/delete-service-details', payload);
  }

  eolMachineList(params?: any) {
    const queryParams: any = {};
    if (params?.site_id) {
      queryParams.site_id = params.site_id;
    }
    if (params?.machine_id) {
      queryParams.machine_id = params.machine_id;
    }
    return this.http.get(this.baseUrl + 'machine/get-eol-machine-list', { params: queryParams });
  }

  updateEolMachineStatus(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'machine/update-eol-machine-status', payload);
  }

  //get machineInstance details
  getMachineInstanceDetails(machineInstanceId: string) {
    return this.http.get(this.baseUrl + `machine/machine-instance-details/${machineInstanceId}`);
  }

  bulkDeleteSiteMachine(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'machine/bulk-delete-site-machine', payload);
  }

  getAllClientSiteDetails(clientId: string) {
    return this.http.get(this.baseUrl + `site/get-client-site-details/${clientId}`);
  }

  getPartsRequestDetails(jobId: string): Observable<any> {
    return this.http.get(this.baseUrl + `machine/get-parts-request-details/${jobId}`);
  }

  getMachineReplacementDetails(jobId: string): Observable<any> {
    return this.http.get(this.baseUrl + `machine/get-machine-replacement-details/${jobId}`);
  }

  getPartNameListAc(query: string, queryParams: any = {}): Observable<any> {
    let params = {
      query,
      ...queryParams,
    };

    return this.http.get(this.baseUrl + `jobs/part-name-ac`, {
      params,
    });
  }

  getUnassignedClientSiteDetails(clientId: string) {
    return this.http.get(this.baseUrl + `site/get-unAssigned-client-site-details/${clientId}`);
  }

  getAreaManagerSiteList(id: string) {
    return this.http.get(this.baseUrl + `site/area-manager-site-list/${id}`);
  }

  //Restore client
  restoreClient(clientId: string): Observable<any> {
    return this.http.post(this.baseUrl + `manageClient/${clientId}/restore`, {});
  }

  //Deleted client list
  deletedClientList() {
    return this.http.get(this.baseUrl + 'manageClient/get-deleted-clients');
  }

  //Serial no list
  getAllSerialNo(machineId: string, type: string | null) {
    let url = this.baseUrl + `machine/get-machine-instance-details/${machineId}`;

    if (type) {
      url += `?type=${type}`;
    }

    return this.http.get(url);
  }

  // Add Serial No Form
  addSerialNO(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'machine/add-serialNo', payload);
  }

  // Dashboard
  getCountHighights(): Observable<any> {
    return this.http.post(this.baseUrl + 'admin/dashboard/counts', {});
  }

  getLiveEngineerLocation(): Observable<any> {
    return this.http.post(this.baseUrl + 'admin/dashboard/live-engineer-location', {});
  }

  getTlsMachineList(params: any = {}): Observable<any> {
    return this.http.post(this.baseUrl + 'admin/dashboard/tls-machines', params);
  }

  getMachineTypeWiseData(params: any = {}): Observable<any> {
    return this.http.post(this.baseUrl + 'admin/dashboard/machine-type', params);
  }

  getDashboardSiteData(params: any = {}): Observable<any> {
    return this.http.post(this.baseUrl + 'admin/dashboard/sites', params);
  }

  getExportMachineList(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'machine/export-machines', payload);
  }
  getJobCountsByRange(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'admin/dashboard/job-calendar', payload);
  }

  getCountryWiseJobTrendsData(params: any = {}): Observable<any> {
    return this.http.post(this.baseUrl + 'admin/dashboard/country-wise-job-trends', params);
  }

  siteMachineList(params: any = {}): Observable<any> {
    return this.http.post(this.baseUrl + 'machine/site-machine-list', params);
  }

  importMachine(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'machine/import-machine', payload);
  }

  getWorkShopListData() {
    return this.http.get(this.baseUrl + 'machine/workshop-machine-list');
  }

  getmachineSerialNoData(payload: any) {
    return this.http.post(this.baseUrl + 'machine/machine-instance-list', payload);
  }

  // job types
  getJobTypes(
    filters: Object = { deletedAt: null, active: 1 },
    orderBy: Record<string, 1 | -1> = { name: 1 }
  ): Observable<any> {
    let params = { filters, orderBy };
    return this.http.post(this.baseUrl + 'jobs/job-types', params);
  }

  createJobType(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'jobs/job-types/create', payload);
  }

  updateJobType(jobTypeId: string, payload: any): Observable<any> {
    return this.http.post(this.baseUrl + `jobs/job-types/${jobTypeId}/update`, payload);
  }

  deleteJobType(jobTypeId: string, payload: any = {}): Observable<any> {
    return this.http.post(this.baseUrl + `jobs/job-types/${jobTypeId}/delete`, payload);
  }

  blockUnblockJobType(jobTypeId: string, payload: any): Observable<any> {
    return this.http.post(this.baseUrl + `jobs/job-types/${jobTypeId}/status-change`, payload);
  }

  bulkDeleteBlockUnblockJobType(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'jobs/job-types/bulk-update', payload);
  }

  putJobOnhold(jobId: string, payload: any = {}): Observable<any> {
    return this.http.post(this.baseUrl + `jobs/${jobId}/put-on-hold-special`, payload);
  }

  restoreMachineApi(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'machine/restore-workshop-machine', payload);
  }

  assignUnassignLocationApi(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'machine/assign-unassign-site', payload);
  }

  bulkAssignUnassignLocationApi(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'machine/bulk-assign-unassign-site', payload);
  }

  importAssignSite(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'site/import-assign-site', payload);
  }

  getPatJobList(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'jobs/get-pat-jobs', payload);
  }

  addScheduledPAT(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'site/add-pat-schedule', payload);
  }

  deleteScheduledPAT(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'site/delete-pat-schedule', payload);
  }

  // Parts Management
  createPartsApi(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'parts/add-parts', payload);
  }

  listPartsApi(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'parts/parts-list', payload);
  }

  productGroupDropDownApi(): Observable<any> {
    return this.http.get(this.baseUrl + 'parts/product-group-list');
  }

  updatePartsStatusApi(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'parts/update-part-status', payload);
  }

  deletePartsStatusApi(partId: string): Observable<any> {
    return this.http.post(this.baseUrl + `parts/${partId}/delete-part`, {});
  }

  viewPartsApi(partId: string): Observable<any> {
    return this.http.get(this.baseUrl + `parts/get-part-details/${partId}`);
  }

  bulkUpdatePartsApi(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'parts/bulk-update-part', payload);
  }

  //Prices Management
  createPricesApi(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'parts/add-prices', payload);
  }

  listPricesApi(partId: any): Observable<any> {
    return this.http.get(this.baseUrl + `parts/get-price-details/${partId}`);
  }

  //Quotes Management
  quotesListApi(payload: any) {
    return this.http.post(this.baseUrl + 'quote/quotes-list', payload);
  }

  sendQuotesApi(payload: any) {
    return this.http.post(this.baseUrl + 'quote/save-quote', payload);
  }

  // getNextQuoteID() {
  //   return this.http.post(this.baseUrl + 'quote/get-next-quote-id', {});
  // }

  //Manage Leads
  leadList(payload: any) {
    return this.http.post(this.baseUrl + 'leads/lead-list', payload);
  }

  archivedLeadList(payload: any) {
    return this.http.post(this.baseUrl + 'leads/archived-leads', payload);
  }

  createLead(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'leads/add-lead', payload);
  }

  archiveLead(id: string): Observable<any> {
    return this.http.post(this.baseUrl + `leads/${id}/archive-lead`, {});
  }

  restoreLead(id: string): Observable<any> {
    return this.http.post(this.baseUrl + `leads/${id}/restore-lead`, {});
  }

  deleteLead(id: string): Observable<any> {
    return this.http.post(this.baseUrl + `leads/${id}/delete-lead`, {});
  }

  leadStatusChange(id: string, payload: any): Observable<any> {
    return this.http.post(this.baseUrl + `leads/${id}/change-status`, payload);
  }

  addLeadContact(id: string, contact: any): Observable<any> {
    return this.http.post(this.baseUrl + `leads/${id}/add-contact`, {
      contact: contact,
    });
  }
  updateLeadContact(id: string, contactId: string, contact: any): Observable<any> {
    return this.http.post(this.baseUrl + `leads/${id}/update-contact`, {
      contactId: contactId,
      contact: contact,
    });
  }

  leadWiseDeals(id: string) {
    return this.http.get(this.baseUrl + `leads/${id}/deals`);
  }

  leadWiseProposals(id: string) {
    return this.http.get(this.baseUrl + `leads/${id}/proposals`);
  }

  updateLeadDetails(id: string, payload: any): Observable<any> {
    return this.http.post(this.baseUrl + `leads/${id}/update-lead`, payload);
  }

  getLeadDetails(id: string) {
    return this.http.get(this.baseUrl + `leads/${id}/view-lead`);
  }

  getLeadContacts(id: string) {
    return this.http.get(this.baseUrl + `leads/${id}/get-contacts`);
  }

  viewLead(id: string) {
    return this.http.get(this.baseUrl + `leads/${id}/lead-details`);
  }

  deleteLeadContact(id: string, contactId: string): Observable<any> {
    return this.http.post(this.baseUrl + `leads/${id}/delete-contact`, {
      contactId: contactId,
    });
  }

  importContacts(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'leads/import-contacts', payload);
  }

  updateLeadStatus(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'leads/update-lead-status', payload);
  }

  autoCompleteLeads(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'leads/autoComplete-lead-list', payload);
  }

  importLead(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'leads/import-lead', payload);
  }

  //Deal list
  dealList(payload: any) {
    return this.http.post(this.baseUrl + 'deal/get-all-deals', payload);
  }

  autoCompleteDeals(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'deal/autoComplete-deal-list', payload);
  }

  userLeadList(payload: any) {
    return this.http.post(this.baseUrl + 'leads/my-leads', payload);
  }

  archivedDeal(payload: any) {
    return this.http.post(this.baseUrl + 'deal/archived-deals', payload);
  }

  createDeal(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'deal/add-deal', payload);
  }

  importDeal(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'deal/import-deal', payload);
  }

  updateDeal(payload: any): Observable<any> {
    return this.http.put(this.baseUrl + 'deal/update-deal', payload);
  }

  dealStatusChange(id: string, payload: any): Observable<any> {
    return this.http.post(this.baseUrl + `deal/${id}/change-status`, payload);
  }

  // deleteDeal(id: string): Observable<any> {
  //   // dealId, deletedBy
  //   return this.http.patch(this.baseUrl + `deal/soft-delete-deal`, {dealId:id});
  // }

  // FetchDeal(id: any): Observable<any> {
  //   return this.http.get(this.baseUrl + 'deal/single-deal', {
  //     params: { _id: id }
  //   });
  // }

  FetchDeal(id: any): Observable<any> {
    return this.http.get(this.baseUrl + 'deal/single-deal', {
      params: { _id: id },
    });
  }

  dealUpdate(/* id: string, */ payload: any): Observable<any> {
    return this.http.put(this.baseUrl + `deal/update-deal`, payload);
  }

  archiveDeal(id: string): Observable<any> {
    return this.http.patch(this.baseUrl + `deal/soft-delete-deal`, {
      dealId: id,
    });
  }

  restoreDeal(id: string): Observable<any> {
    return this.http.post(this.baseUrl + `deal/${id}/restore-deal`, {});
  }

  deleteDeal(id: string): Observable<any> {
    return this.http.post(this.baseUrl + `deal/${id}/hard-delete-deal`, {});
  }

  //Dashboard API
  dashboardCounts(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'dashboard/all-counts', payload);
  }

  // proposal
  createProposal(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'proposal/add-proposal', payload);
  }
  updateProposal(payload: any): Observable<any> {
    return this.http.put(this.baseUrl + `proposal/update-proposal`, payload);
  }
  proposalListByLead(leadId: any) {
    return this.http.get(this.baseUrl + `proposal/${leadId}/list-proposal`);
  }

  // Documents
  addDocument(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'leads/documents/add-document', payload);
  }
  updateDocument(id: any, payload: any): Observable<any> {
    return this.http.post(this.baseUrl + `leads/documents/${id}/update-document`, payload);
  }
  documentListByLead(leadId: any) {
    return this.http.get(this.baseUrl + `leads/documents/${leadId}/get-documents`);
  }
  deleteDocument(id: any): Observable<any> {
    return this.http.post(this.baseUrl + `leads/documents/${id}/delete-document`, {});
  }

  //Call log
  createCallLog(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'callLog/add-callLog', payload);
  }

  callLogList(leadId: any) {
    return this.http.get(this.baseUrl + `callLog/${leadId}/list-callLog`);
  }

  //Task
  createTask(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'tasks/add-task', payload);
  }

  updateTask(payload: any, id: any): Observable<any> {
    return this.http.put(this.baseUrl + `tasks/${id}/update-task`, payload);
  }

  taskList(leadId: any) {
    return this.http.get(this.baseUrl + `tasks/${leadId}/task-list`);
  }

  deleteTask(taskId: string): Observable<any> {
    return this.http.put(this.baseUrl + `tasks/delete-task?id=${taskId}`, {});
  }

  changeTaskStatus(id: any): Observable<any> {
    return this.http.put(this.baseUrl + `tasks/${id}/change-task-status`, {});
  }

  // lead emails
  listLeadEmails(leadId: string): Observable<any> {
    return this.http.get(this.baseUrl + `leads/${leadId}/emails`, {
      params: {
        // leadId
      },
    });
  }

  addLeadEmail(leadId: string, payload: any): Observable<any> {
    return this.http.post(this.baseUrl + `leads/${leadId}/emails`, payload);
  }

  deleteLeadEmail(leadId: string, emailId: string): Observable<any> {
    return this.http.delete(this.baseUrl + `leads/${leadId}/emails/${emailId}`);
  }

  updateLeadEmail(leadId: string, emailId: string, payload: any): Observable<any> {
    return this.http.put(this.baseUrl + `leads/${leadId}/emails/${emailId}`, payload);
  }

  getLeadEmailDetails(leadId: string, emailId: string): Observable<any> {
    return this.http.get(this.baseUrl + `leads/${leadId}/emails/${emailId}`);
  }

  sendLeadEmail(leadId: string, emailId: string, payload: any): Observable<any> {
    return this.http.post(this.baseUrl + `leads/${leadId}/emails/${emailId}/send`, payload);
  }

  followupEmail(emailId: any): Observable<any> {
    return this.http.post(this.baseUrl + `leads/${emailId}/email-followup`, {});
  }

  /*
    :leadId/meetings/
    :leadId/meetings/
    :leadId/meetings/:id
    :leadId/meetings/:id
    :leadId/meetings/:id
    :leadId/follow-up
  */
  listLeadMeetings(leadId: string): Observable<any> {
    return this.http.get(this.baseUrl + `leads/${leadId}/meetings`);
  }

  addLeadMeeting(leadId: string, payload: any): Observable<any> {
    return this.http.post(this.baseUrl + `leads/${leadId}/meetings`, payload);
  }

  updateLeadMeeting(leadId: string, meetingId: string, payload: any): Observable<any> {
    return this.http.put(this.baseUrl + `leads/${leadId}/meetings/${meetingId}`, payload);
  }

  deleteLeadMeeting(leadId: string, meetingId: string): Observable<any> {
    return this.http.delete(this.baseUrl + `leads/${leadId}/meetings/${meetingId}`);
  }

  getLeadMeetingDetails(leadId: string, meetingId: string): Observable<any> {
    return this.http.get(this.baseUrl + `leads/${leadId}/meetings/${meetingId}`);
  }

  //Notification API
  notiFicationList(): Observable<any> {
    return this.http.get(this.baseUrl + `notification/notification-list`);
  }

  markNotificationAsRead(id: string): Observable<any> {
    return this.http.post(this.baseUrl + `notification/${id}/read-notification`, {});
  }

  markAllNotificationsAsRead(): Observable<any> {
    return this.http.post(this.baseUrl + 'notification/read-all-notification', {});
  }

  addMeetingFollowUp(leadId: string, meetingId: string, payload: any): Observable<any> {
    return this.http.post(
      this.baseUrl + `leads/${leadId}/meetings/${meetingId}/follow-up`,
      payload
    );
  }

  /*
    post "/:leadId/follow-ups/"
    get "/:leadId/follow-ups/"
    get "/:leadId/follow-ups/:id"
    put "/:leadId/follow-ups/:id"
    delete "/:leadId/follow-ups/:id"
  */

  listLeadFollowUps(leadId: string): Observable<any> {
    return this.http.get(this.baseUrl + `leads/${leadId}/follow-ups`);
  }

  addLeadFollowUp(leadId: string, payload: any): Observable<any> {
    return this.http.post(this.baseUrl + `leads/${leadId}/follow-ups`, payload);
  }

  updateLeadFollowUp(leadId: string, followUpId: string, payload: any): Observable<any> {
    return this.http.put(this.baseUrl + `leads/${leadId}/follow-ups/${followUpId}`, payload);
  }

  deleteLeadFollowUp(leadId: string, followUpId: string): Observable<any> {
    return this.http.delete(this.baseUrl + `leads/${leadId}/follow-ups/${followUpId}`);
  }

  getLeadFollowUpDetails(leadId: string, followUpId: string): Observable<any> {
    return this.http.get(this.baseUrl + `leads/${leadId}/follow-ups/${followUpId}`);
  }

  // Report API
  saveReport(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'reports/save-report', payload);
  }

  fetchReport(id: string) {
    return this.http.get(this.baseUrl + `reports/${id}/fetch-report`);
  }

  deleteReport(id: string): Observable<any> {
    return this.http.post(this.baseUrl + `reports/${id}/delete-report`, {});
  }

  // activities
  getActivitiesList(leadId: string, payload: any): Observable<any> {
    return this.http.post(this.baseUrl + `leads/${leadId}/activities`, payload);
  }

  // activities-grouped
  getActivitiesGrouped(leadId: string, payload: any): Observable<any> {
    return this.http.post(this.baseUrl + `leads/${leadId}/activities-grouped`, payload);
  }
  // all-activities-grouped
  getAllActivitiesGrouped(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + `leads/all-activities-grouped`, payload);
  }
  // all-activities-all-activities-paginated
  getAllActivitiesPaginated(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + `leads/all-activities-paginated`, payload);
  }

  // activity-logs-paginated
  getActivityLogsPaginated(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + `leads/activity-logs-paginated`, payload);
  }

  // update company logo
  updateCompanyLogo(
    leadId: string,
    payload: { logo?: string; deleteLogo?: true }
  ): Observable<any> {
    return this.http.post(this.baseUrl + `leads/${leadId}/update-company-logo`, payload);
  }

  // Quote API
  getNextQuoteID() {
    return this.http.post(this.baseUrl + 'quotes/get-next-quoteid', {});
  }

  fetchQuoteItems() {
    return this.http.post(this.baseUrl + 'quotes/fetch-quote-items', {});
  }

  addQuote(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'quotes/add-quote', payload);
  }

  quoteList(leadId: any) {
    return this.http.get(this.baseUrl + `quotes/${leadId}/get-quotes`);
  }

  deleteQuote(id: any): Observable<any> {
    return this.http.post(this.baseUrl + `quotes/${id}/delete-quote`, {});
  }

  updateQuote(id: any, payload: any): Observable<any> {
    return this.http.post(this.baseUrl + `quotes/${id}/update-quote`, payload);
  }

  //Send to mobilization
  sendProject(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + `deal/add-project`, payload);
  }

  //Save Client
  addClient(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'onboardClients/add-client', payload);
  }

  onboardClientList(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'onboardClients/list-Clients', payload);
  }

  getClientDetails(id: string) {
    return this.http.get(this.baseUrl + `onboardClients/get-single-client/${id}`);
  }

  autoCompleteClients(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'onboardClients/autoComplete-client-list', payload);
  }

  deleteClient(id: any): Observable<any> {
    return this.http.put(this.baseUrl + `onboardClients/delete-client-contract/${id}`, {});
  }

  //lms   service start here

  getCourseList(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'course/list-courses', payload);
  }

  getArchivedCourseList(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'course/archived-courses', payload);
  }

  createCourse(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'course/create-course', payload);
  }

  duplicateCourse(courseId: string, payload: { assignmentType: string; learnerIds: string[]; teamIds: string[] }): Observable<any> {
    return this.http.post(this.baseUrl + `course/duplicate-course/${courseId}`, payload);
  }

  updateCourse(id: string, payload: any): Observable<any> {
    return this.http.put(this.baseUrl + `course/update-course/${id}`, payload);
  }

  updateCourseStatus(id: string, payload: { status: number }): Observable<any> {
    return this.http.patch(this.baseUrl + `course/update-course-status/${id}`, payload);
  }

  deleteCourse(id: string): Observable<any> {
    return this.http.patch(this.baseUrl + `course/delete-course/${id}`, {});
  }

  getCourseStats(): Observable<any> {
    return this.http.get(this.baseUrl + 'course/course-stats-count');
  }

  dashboardCountsLms(): Observable<any> {
    return this.http.get(this.baseUrl + 'courseUser/dashboard-stats');
  }

  getCourseDetails(id: string): Observable<any> {
    return this.http.get(this.baseUrl + `course/course-detail/${id}`);
  }

  getCourseDetailsforlearner(id: string): Observable<any> {
    return this.http.get(this.baseUrl + `learner/courseDetailsForLearner/${id}`);
  }

  addPage(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'page/add-page', payload);
  }

  updatePage(id: string, payload: any): Observable<any> {
    return this.http.put(this.baseUrl + `page/update-page/${id}`, payload);
  }

  deletePage(id: string): Observable<any> {
    return this.http.patch(this.baseUrl + `page/delete-page/${id}`, {});
  }

  copyPage(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'page/copy-page', payload);
  }

  resetTestType(pageId: string): Observable<any> {
    return this.http.patch(this.baseUrl + `page/reset-test-type/${pageId}`, {});
  }

  addSection(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'section/create-section', payload);
  }

  getSectionsByPageId(pageId: string): Observable<any> {
    return this.http.get(this.baseUrl + `section/section-list?pageId=${pageId}`);
  }

  updateSection(id: string, payload: any): Observable<any> {
    return this.http.put(this.baseUrl + `section/update/${id}`, payload);
  }

  deleteSection(id: string): Observable<any> {
    return this.http.patch(this.baseUrl + `section/delete/${id}`, {});
  }

  copySection(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'section/copy-section', payload);
  }

  addQuestion(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'question/add-question', payload);
  }

  getTeamList(page: number = 1, limit: number = 10): Observable<any> {
    return this.http.get(`${this.baseUrl}team/list-teams?page=${page}&limit=${limit}`);
  }

  getAllTeamsForAssignment(): Observable<any> {
    return this.http.get(`${this.baseUrl}team/all-teams-assignment`);
  }

  getPublishedCourses(
    params: { page?: number; limit?: number; search?: string } = {}
  ): Observable<any> {
    let queryParams = new HttpParams()
      .set('page', (params.page || 1).toString())
      .set('limit', (params.limit || 8).toString());

    if (params.search) {
      queryParams = queryParams.set('search', params.search);
    }

    return this.http.post(this.baseUrl + 'course/published-courses', {}, { params: queryParams });
  }

  getAllUsers(): Observable<any> {
    return this.http.get(this.baseUrl + 'user/all-users');
  }

  /**
   * Lightweight version of getAllUsers — returns only essential fields
   * (_id, name, firstName, lastName, email, role_number).
   * Skips the expensive loginlogoutevents lookup on the server.
   * Use this for dropdowns, selectors, and filters.
   */
  getAllUsersMinimal(): Observable<any> {
    return this.http.get(this.baseUrl + 'user/all-users', {
      params: { fields: 'minimal' }
    });
  }

  getAreaManagerLearners(userId: string): Observable<any> {
    return this.http.get(this.baseUrl + `user/${userId}/area-manager-learners`);
  }

  getUsersPaginated(params: {
    page?: number;
    limit?: number;
    search?: string;
    excludeRoles?: number[];
    courseId?: string;
  }): Observable<any> {
    let queryParams = new HttpParams()
      .set('page', (params.page || 1).toString())
      .set('limit', (params.limit || 50).toString());

    if (params.search) {
      queryParams = queryParams.set('search', params.search);
    }
    if (params.excludeRoles && params.excludeRoles.length > 0) {
      queryParams = queryParams.set('excludeRoles', params.excludeRoles.join(','));
    }
    if (params.courseId) {
      queryParams = queryParams.set('courseId', params.courseId);
    }

    return this.http.get(this.baseUrl + 'user/users-paginated', { params: queryParams });
  }

  assignUserToCourse(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'courseUser/assign-user-to-course', payload);
  }

  unassignUserFromCourse(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'courseUser/unassign-user-from-course', payload);
  }

  getStaffUnderTraining(
    params: { page?: number; limit?: number; search?: string } = {}
  ): Observable<any> {
    const cacheKey = `staff-training-${params.page || 1}-${params.limit || 20}-${params.search || ''}`;

    // Check cache first (only for first page without search)
    if ((params.page || 1) === 1 && !params.search && this.cacheService.has(cacheKey)) {
      return of(this.cacheService.get(cacheKey));
    }

    const queryParams = new HttpParams()
      .set('page', (params.page || 1).toString())
      .set('limit', (params.limit || 20).toString())
      .set('search', params.search || '');

    return this.http
      .get(this.baseUrl + 'courseUser/staff-under-training', { params: queryParams })
      .pipe(
        tap(response => {
          // Cache only first page without search for 2 minutes
          if ((params.page || 1) === 1 && !params.search) {
            this.cacheService.set(cacheKey, response, 2 * 60 * 1000);
          }
        })
      );
  }

  assignTeamToCourse(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'courseTeam/assign-team-to-course', payload);
  }

  unassignTeamFromCourse(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'courseTeam/unassign-team-from-course', payload);
  }

  updateLayout(payload: any): Observable<any> {
    return this.http.patch(this.baseUrl + 'course/update-layout', payload);
  }

  getPageDetails(pageId: string): Observable<any> {
    return this.http.get(this.baseUrl + `page/page-detail/${pageId}`);
  }
  getPageDetailsforlearner(pageId: string): Observable<any> {
    return this.http.get(this.baseUrl + `page/page-detail-learner/${pageId}`);
  }

  permanentDeleteCourse(id: string): Observable<any> {
    return this.http.delete(this.baseUrl + `course/permanent-delete-course/${id}`);
  }

  restoreArchivedCourse(id: string): Observable<any> {
    return this.http.patch(this.baseUrl + `course/undo-archive-course/${id}`, {});
  }

  userLoginCount(): Observable<any> {
    return this.http.get(this.baseUrl + 'user/user-login-stats');
  }

  deleteQuestion(id: string): Observable<any> {
    return this.http.patch(this.baseUrl + `question/delete-question/${id}`, {});
  }
  updateEmailPermission(payload: { userId: string; emailPermission: boolean }): Observable<any> {
    return this.http.post(this.baseUrl + 'projectUser/update-email-permission', payload);
  }
  /**
   * Learner Service
   */
  getLearnerCourseList(): Observable<any> {
    return this.http.get(this.baseUrl + 'learner/assignedCourseList');
  }

  getLearnermyCourseList(): Observable<any> {
    return this.http.get(this.baseUrl + 'learner/assignedCourseListforLearnermycoursecomponent');
  }

  answerQuestion(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'learner/answerQuestion', payload);
  }

  bulkSubmitAnswers(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'learner/bulkSubmitAnswers', payload);
  }

  learnerCompletedCourses(): Observable<any> {
    return this.http.get(this.baseUrl + 'learner/learnerCompletedCourses');
  }
  getAllCoursesforcertificatedropdown(): Observable<any> {
    return this.http.get(this.baseUrl + '/course/get-all-course');
  }

  createCertificate(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'certificate/create-templates', payload);
  }

  getCourseReports(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'reports/course-reports', payload);
  }

  getClientListForReport(): Observable<any> {
    return this.http.get(this.baseUrl + 'reports/client-list');
  }

  getCountriesByClients(clientIds: string[]): Observable<any> {
    return this.http.post(this.baseUrl + 'reports/countries-by-clients', { clientIds });
  }

  submitClientReport(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'reports/submit-client-report', payload);
  }

  getCreatedByOptionsForReport(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'reports/created-by-options', payload);
  }

  getLearnerReports(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'reports/learner-reports', payload);
  }

  //  for report

  getCourseListforreport(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'course/list-courses', payload);
  }

  getTeamListforreport(page: number = 1, limit: number = 100): Observable<any> {
    return this.http.post(`${this.baseUrl}team/list-teams`, { page, limit });
  }

  getAlllearnersforreport(): Observable<any> {
    return this.http.get(this.baseUrl + 'user/all-users');
  }

  getLearnersForFilter(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/learners-for-filter', payload);
  }

  getAreaManagersForFilter(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/area-managers-for-filter', payload);
  }

  getAllCertificateTemplates(): Observable<any> {
    return this.http.get(this.baseUrl + '/certificate/get-all-templates');
  }

  getCertificateTemplateById(id: string): Observable<any> {
    return this.http.get(this.baseUrl + `/certificate/get-template-by-id/${id}`);
  }

  updateCertificateTemplate(payload: any): Observable<any> {
    return this.http.put(this.baseUrl + 'certificate/update-templates', payload);
  }

  deleteCertificateTemplate(id: string): Observable<any> {
    return this.http.patch(this.baseUrl + `/certificate/delete-templates/${id}`, {});
  }

  getLearnerCertificates(): Observable<any> {
    return this.http.get(this.baseUrl + 'certificate/get-learner-certificates');
  }

  getTrainingCompletionChart(): Observable<any> {
    return this.http.get(this.baseUrl + 'courseUser/training-completion-chart');
  }

  calculateCourseProgress(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'courseUser/calculate-course-progress', payload);
  }

  exportCourseToPdf(courseId: string): Observable<any> {
    return this.http.get(this.baseUrl + `learner/pdfexport/${courseId}`);
  }

  downloadPdf(url: string, fileName: string): void {
    const link = document.createElement('a');
    link.href = url;
    link.download = fileName;
    link.target = '_blank';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
  ss(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'course-progress/calculate', payload);
  }

  markCourseStarted(payload: { courseId: string }): Observable<any> {
    return this.http.post(this.baseUrl + 'learner/markCourseStarted', payload);
  }

  removeThumbnail(id: string): Observable<any> {
    return this.http.patch(this.baseUrl + `course/remove-thumbnail/${id}`, {});
  }

  getCourseCategoryList(): Observable<any> {
    return this.http.get(this.baseUrl + 'course-category/allcategories');
  }

  getAllPaths(): Observable<any> {
    return this.http.get(this.baseUrl + 'path/allpaths');
  }

  getPublishedCoursesLearnerUniversity(
    params: { page?: number; limit?: number } = {}
  ): Observable<any> {
    const queryParams = new HttpParams()
      .set('page', (params.page || 1).toString())
      .set('limit', (params.limit || 6).toString());

    return this.http.post(
      this.baseUrl + 'course/published-courses-learneruniversity',
      {},
      { params: queryParams }
    );
  }

  selfAssignLearnerToCourse(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'courseUser/selfassign-learner-to-course', payload);
  }

  getLearnerPathLevel(userId?: string): Observable<any> {
    let params = new HttpParams();
    if (userId) {
      params = params.set('userId', userId);
    }
    return this.http.get(this.baseUrl + 'shop/learnerpathlevel', { params });
  }

  getLearnerProfile(): Observable<any> {
    return this.http.get(this.baseUrl + 'user-badge-path/profile');
  }

  getLearnerCourseHistory(): Observable<any> {
    return this.http.get(this.baseUrl + 'user-badge-path/course-history');
  }

  learnerLevelProgress(): Observable<any> {
    return this.http.get(this.baseUrl + 'user-badge-path/path-progress');
  }

  getUserBadges(): Observable<any> {
    return this.http.get(this.baseUrl + 'user-badge-path/badges');
  }

  getSiteLeaderboard(): Observable<any> {
    return this.http.get(this.baseUrl + 'user-badge-path/site-leaderboard');
  }

  getCountrySitesLeaderboard(): Observable<any> {
    return this.http.get(this.baseUrl + 'user-badge-path/country-sites-leaderboard');
  }

  learnerLocationLeaderboard(): Observable<any> {
    return this.http.get(this.baseUrl + 'user-badge-path/country-leaderboard');
  }

  getGlobalLeaderboard(): Observable<any> {
    return this.http.get(this.baseUrl + 'user-badge-path/global-leaderboard');
  }

  learnerGlobalLeaderboard(): Observable<any> {
    return this.http.get(this.baseUrl + 'user-badge-path/global-leaderboard');
  }


  getLearnerProducts(): Observable<any> {
    return this.http.get(this.baseUrl + 'product/learnerproducts');
  }

  redeemProduct(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'learner-product/redeem', payload);
  }

  getLearnerRedemptionHistory(): Observable<any> {
    return this.http.get(this.baseUrl + 'learner-product/redemption-history');
  }

  getAllLearnersRedemptionHistory(): Observable<any> {
    return this.http.get(this.baseUrl + 'learner-product/all-redemption-history');
  }

  getTotalCounts(): Observable<any> {
    return this.http.get(this.baseUrl + 'user-badge-path/total-counts');
  }

  getAdminCountryLeaderboard(countryIds: string[]): Observable<any> {
    return this.http.post(this.baseUrl + 'user-badge-path/admin-country-leaderboard', {
      countryIds,
    });
  }

  updateRedemptionStatus(redemptionId: string, status: string): Observable<any> {
    return this.http.put(this.baseUrl + 'learner-product/update-status', { redemptionId, status });
  }

  getLearnerProfileAdmin(
    userId?: string,
    page?: number,
    limit?: number,
    userIds?: string[]
  ): Observable<any> {
    return this.http.post(this.baseUrl + 'user-badge-path/profile-admin', {
      userId,
      page,
      limit,
      userIds,
    });
  }

  getLearnerProfileByUserId(userId: string): Observable<any> {
    return this.http.get(this.baseUrl + `user-badge-path/profile-by-userid?userId=${userId}`);
  }

  getUserLevelProgressByUserId(userId: string): Observable<any> {
    return this.http.get(this.baseUrl + `user-badge-path/path-progress-by-userid?userId=${userId}`);
  }

  getLearnerCourseHistoryByUserId(userId: string): Observable<any> {
    return this.http.get(
      this.baseUrl + `user-badge-path/course-history-by-userid?userId=${userId}`
    );
  }

  getRedemptionHistoryByUserId(userId: string): Observable<any> {
    return this.http.get(
      this.baseUrl + `learner-product/redemption-history-by-userid?userId=${userId}`
    );
  }

  getUserBadgesByUserId(userId: string): Observable<any> {
    return this.http.get(this.baseUrl + `user-badge-path/badges-by-userid?userId=${userId}`);
  }

  getAssignedCoursesForLearnerByAdmin(userId: string): Observable<any> {
    return this.http.get(this.baseUrl + `learner/assignedCoursesForLearnerByAdmin?userId=${userId}`);
  }

  adminMarkCourseComplete(payload: { userId: string; courseId: string }): Observable<any> {
    return this.http.post(this.baseUrl + 'learner/adminMarkCourseComplete', payload);
  }

  manualSendCompletedStatus(userId: string): Observable<any> {
    return this.http.post(this.baseUrl + 'deputy-learning-path/manual-complete', { userId });
  }

  getDeputySyncStatus(userId: string): Observable<any> {
    return this.http.get(this.baseUrl + `deputy-learning-path/sync-status/${userId}`);
  }

  assignLearnersToAreaManager(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/assign-learners', payload);
  }

  getCmLearners(userId: string, page: number = 1, limit: number = 50): Observable<any> {
    return this.http.get(this.baseUrl + `user/${userId}/cm-learners?page=${page}&limit=${limit}`);
  }

  generateLearnerReport(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'reports/generate-learner-report', payload);
  }

  generateCourseReport(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'reports/generate-course-report', payload);
  }

  getGeneratedReports(params: { reportType?: string; filterType?: string; page?: number; limit?: number } = {}): Observable<any> {
    let queryParams = new HttpParams()
      .set('page', (params.page || 1).toString())
      .set('limit', (params.limit || 20).toString());

    if (params.reportType) {
      queryParams = queryParams.set('reportType', params.reportType);
    }
    if (params.filterType) {
      queryParams = queryParams.set('filterType', params.filterType);
    }

    return this.http.get(this.baseUrl + 'reports/generated-reports', { params: queryParams });
  }

  downloadGeneratedReport(reportId: string): Observable<any> {
    return this.http.get(this.baseUrl + `reports/download-report/${reportId}`);
  }

  downloadFileEntry(reportId: string, fileIndex: number): Observable<any> {
    return this.http.get(this.baseUrl + `reports/download-file/${reportId}/${fileIndex}`);
  }

  deleteGeneratedReport(reportId: string): Observable<any> {
    return this.http.delete(this.baseUrl + `reports/delete-report/${reportId}`);
  }

  // ── Report Dashboard APIs ──────────────────────────────────────────────
  getDashboardKpiStats(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'reports/dashboard-kpi-stats', payload);
  }

  getDashboardMonthlyChart(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'reports/dashboard-monthly-chart', payload);
  }

  getDashboardCategoryStats(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'reports/dashboard-category-stats', payload);
  }

  getDashboardTopCourses(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'reports/dashboard-top-courses', payload);
  }

  getDashboardCountryStats(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'reports/dashboard-country-stats', payload);
  }

  getDashboardFilterOptions(): Observable<any> {
    return this.http.get(this.baseUrl + 'reports/dashboard-filter-options');
  }
}
